"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var cross_fetch_1 = require("cross-fetch");
/**
 * Abstract class for shared logic between public and admin api clients
 */
var Client = /** @class */ (function () {
    function Client() {
        this.host = '';
        this.additionalHeaders = {};
        this.setNetwork('testnet');
    }
    Client.getStateMessage = function (code) {
        switch (code) {
            case 0:
                return 'Awaiting payment';
            case 100:
                return 'Paid';
            case 150:
                return 'Payment refunded';
            case 200:
                return 'Queued for opening';
            case 300:
                return 'Channel opening';
            case 350:
                return 'Channel closing';
            case 400:
                return 'Given up';
            case 410:
                return 'Order expired';
            case 450:
                return 'Channel closed';
            case 500:
                return 'Channel open';
        }
        return "Unknown code: " + code;
    };
    Client.prototype.setNetwork = function (network) {
        switch (network) {
            case 'mainnet': {
                this.host = 'https://blocktank.synonym.to/api/';
                break;
            }
            case 'testnet': {
                this.host = 'http://35.233.47.252:443/blocktank/';
                break;
            }
            case 'regtest': {
                throw new Error('Network not yet supported');
                break;
            }
        }
    };
    Client.prototype.setHeaders = function (headers) {
        this.additionalHeaders = __assign(__assign({}, this.additionalHeaders), headers);
    };
    Client.prototype.call = function (path, method, request) {
        return __awaiter(this, void 0, void 0, function () {
            var url, headers, fetchRes, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "" + this.host + path;
                        headers = __assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, this.additionalHeaders);
                        return [4 /*yield*/, (0, cross_fetch_1.default)(url, {
                                method: method,
                                headers: headers,
                                body: request ? JSON.stringify(request) : undefined,
                            })];
                    case 1:
                        fetchRes = _a.sent();
                        if (fetchRes.status !== 200) {
                            throw new Error("HTTP error " + fetchRes.status);
                        }
                        return [4 /*yield*/, fetchRes.json()];
                    case 2:
                        body = _a.sent();
                        if (!body) {
                            throw new Error('Unknown HTTP error');
                        }
                        if (body.error) {
                            throw new Error(body.error);
                        }
                        return [2 /*return*/, body];
                }
            });
        });
    };
    return Client;
}());
exports.default = Client;
